import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async customizeForm() {
    document.getElementById('license_and_customize_form_needs_defined').value = 'false'
    document.getElementById('change_form_type').value = 'customize'
    document.querySelector('form').submit()
  }
}
